import {message} from 'antd';
import {createHashHistory} from "history";
export function fetchPost(url, params) {
    return new Promise((resolve) => fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            mode: 'cors',
            credentials: 'include',
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        })
            .then(checkStatus)
            .then(res => res.json())
            .then(res => {
                // console.log(data)
                // if (res.code === 200||res.code === 201||res.code === 202||res.code === null){
                //     resolve(res)
                //     console.log("获取成功")
                // }
                // else {
                //     reject(res.msg)
                //     message.info(res.msg)
                // }
                resolve(res)
                console.log("获取成功")
            })
    )
}
export function fetchPostFile(url, params) {
    return new Promise((resolve) => fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            mode: 'cors',
            credentials: 'include',
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        })
            .then(checkStatus)
            .then(res => {
                resolve(res)
                console.log("获取成功")
            })
    )
}
export function  fetchGet(url,params){
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }
    //fetch请求
    return new Promise((resolve, reject) =>fetch(url,{
        method: 'GET',
    })
        // .then(checkStatus)
        .then(res => res.json())
        .then((res) => {
            console.log(res)
            if (res.code === 200||res.code === null) {//这里取决于后端给你返回的status，有时候后端返回的不只是success，还有可能是null（宝银学长牛逼）
                resolve(res)
                console.log("获取成功")
            }
            else {
                reject(res.msg)
                message.info(res.msg).then()
            }
        })
    )

}
export function getCurrentDate(separator=''){
    let date = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
}
function checkStatus(res) {
    console.log(res)
    if (res.headers.get("Content-Type")==='text/html;charset=UTF-8') {
        console.log("请登录")
        message.info('重新登录').then()
        createHashHistory().push('/')
        return Promise.reject();
    } else {
        return res
    }
}
